import { useState } from 'react'
import { Draggable } from 'react-beautiful-dnd'
import { Button, Card, CardContent, IconButton, Typography } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'

import { DndBurgerIcon } from 'src/assets/icons'
import { UpdateUnSdgModal } from '../update-un-sdg'
import { IUnSdgBaseWithId } from 'src/types'

import { useStyles } from '../styles'

interface IQuantityTypeCardProps {
  item: IUnSdgBaseWithId
  handleDelete: () => void
  index: number
  orderingDisabled: boolean
}

const UnSdgCard = ({ item, orderingDisabled, handleDelete, index }: IQuantityTypeCardProps) => {
  const [open, setOpen] = useState(false)
  const classes = useStyles()

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <>
      <Draggable draggableId={item.id} index={index}>
        {(provided) => (
          <Card
            className={classes.cardWrapper}
            ref={provided.innerRef}
            {...provided.draggableProps}
          >
            <CardContent className={classes.cardContent}>
              <div className={classes.cardLeftWrapper}>
                <IconButton
                  disabled={orderingDisabled}
                  className={classes.orderIcon}
                  {...provided.dragHandleProps}
                >
                  <DndBurgerIcon />
                </IconButton>
                <Typography className={classes.cardName} component="h4">
                  {item.name}
                </Typography>
              </div>
              <div>
                <Button onClick={handleOpen}>Update</Button>
                <IconButton onClick={handleDelete}>
                  <DeleteIcon />
                </IconButton>
              </div>
            </CardContent>
          </Card>
        )}
      </Draggable>

      <UpdateUnSdgModal handleClose={handleClose} open={open} initialValues={item} />
    </>
  )
}

export { UnSdgCard }
